import {
  AutocompleteItem,
  AutocompleteSelect,
} from '@prismamedia/one-components';
import React, { FC } from 'react';
import { useGetUsers } from './useGetUsers';

interface CreatorSelectProps {
  value?: AutocompleteItem;
  onChange?: (value?: AutocompleteItem) => void;
  className?: string;
}

export const CreatorSelect: FC<CreatorSelectProps> = ({
  value,
  onChange,
  className,
}) => {
  const getUsers = useGetUsers();

  const fetchList = (search: string) =>
    getUsers({
      where: { name_contains: search },
    }).then(({ users }) =>
      users?.map(({ id, name }) => ({ id, label: name || '' })),
    );

  return (
    <AutocompleteSelect
      label="Créateur"
      value={value}
      className={className}
      fetchList={fetchList}
      onChange={onChange}
      mandatoryInput
    />
  );
};
